const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

export function initial(name) {
  const trimmed = (name || '').trim();
  return trimmed ? trimmed.charAt(0).toUpperCase() : '?';
}

export function isOnline(lastSeen) {
  if (!lastSeen) return false;
  return Date.now() - new Date(lastSeen).getTime() < 2 * MINUTE;
}

export function presenceLabel(lastSeen) {
  if (!lastSeen) return 'Offline';
  const diff = Date.now() - new Date(lastSeen).getTime();
  if (diff < 2 * MINUTE) return 'Active now';
  if (diff < HOUR) return `Active ${Math.floor(diff / MINUTE)}m ago`;
  if (diff < DAY) return `Active ${Math.floor(diff / HOUR)}h ago`;
  if (diff < 2 * DAY) return 'Active yesterday';
  if (diff < 7 * DAY) return `Active ${Math.floor(diff / DAY)}d ago`;
  return 'Offline';
}

export function timeAgo(value) {
  if (!value) return '';
  const diff = Date.now() - new Date(value).getTime();
  if (diff < MINUTE) return 'now';
  if (diff < HOUR) return `${Math.floor(diff / MINUTE)}m`;
  if (diff < DAY) return `${Math.floor(diff / HOUR)}h`;
  if (diff < 7 * DAY) return `${Math.floor(diff / DAY)}d`;
  return new Date(value).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

export function clockTime(value) {
  if (!value) return '';
  return new Date(value).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

export function dayKey(value) {
  const d = value ? new Date(value) : new Date();
  return `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
}

export function dayLabel(value) {
  if (!value) return '';
  const date = new Date(value);
  if (dayKey(date) === dayKey(new Date())) return 'Today';
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  if (dayKey(date) === dayKey(yesterday)) return 'Yesterday';
  const withinWeek = Date.now() - date.getTime() < 7 * DAY;
  if (withinWeek) return date.toLocaleDateString(undefined, { weekday: 'long' });
  return date.toLocaleDateString(undefined, { month: 'long', day: 'numeric' });
}
